<div class="mainbox {{userClass}}" [formGroup]="group">
  <div class="inputbox">
    <dp-date-picker
      id="{{name}}"
      name="{{name}}"
      [label]="label"
      [formControl]="formControl()"
      (onChange)="change($event)"
      [disabled]="disabled"
      [mode]="'time'"
      [config]="config"
      [theme]="'dp-material dp-main'">
    </dp-date-picker>
  </div>
  <div *ngIf="f[name].errors?.required && f[name].errors && (f[name].dirty || f[name].touched)" class="error errorsize">
    <div id="requiredValidation" *ngIf="f[name].errors?.required">
      {{label}} {{"ClientApp.Projects.FrameWorkShell.Shared.Controls.TimePicker.NotEntered" | translate}}
    </div>
  </div>
</div>
